import axios from "axios";
import { BASE_URL, API_TOKEN } from "./apis";
import { toast } from "react-toastify";
import { alertToast } from "../components/AlertToast";

export const getLoader = (display) => {
  if (document.querySelector(".MuiBackdrop-root")) {
    document.querySelector(".MuiBackdrop-root").style.display = display;
  }
};

const getBearerToken = () => {
  const token = localStorage.getItem("access_token");
  if (token) {
    try {
      const parsedToken = JSON.parse(token);
      // console.log("Parsed token: ", parsedToken)
      return parsedToken;
    } catch (error) {
      console.error("Failed to parse user from localStorage:", error);
      return null;
    }
  }
  return null;
};

// List of APIs that do not require authentication
const NO_AUTH_REQUIRED_APIS = [
  "/api/passengersapi/login",
  "/api/passengersapi",
  "/api/passengersapi/verifyotp",
  "/api/passengersapi/genrateotp",
  "/api/passengersapi/forgotten",
  "/api/passengersapi/${user_id}/forgottenpassword",
  "/api/contact_numbers/all",
  "/api/faqs",
];

const request = async (method, url, data = {}) => {
  const token = getBearerToken();
  const requiresAuth = !NO_AUTH_REQUIRED_APIS.some((noAuthApi) =>
    url.includes(noAuthApi),
  );

  // console.log("requires auth: ", requiresAuth)

  const axiosInstance = axios.create({
    baseURL: BASE_URL,
    headers: {
      "api-token": API_TOKEN,
      ...(requiresAuth && token && { Authorization: `Bearer ${token}` }), // Add Bearer token only for authenticated APIs
    },
  });

  getLoader("flex");
  try {
    let response = null;
    response = await axiosInstance.request({
      url,
      method,
      data,
    });

    getLoader("none");
    // console.log(response, "repsos");
    return response.data;
  } catch (error) {
    getLoader("none");

    if (error.response?.status === 401) {
      // Clear authentication
      localStorage.removeItem("user");
      localStorage.removeItem("access_token");

      alertToast("Your session has expired. Please login again.").then(
        (confirmed) => {
          if (confirmed) {
            // Redirect to login
            window.location.replace("/");
          }
        },
      );
    }

    return error.response
      ? error.response.data
      : { message: "An unexpected error occurred" };
  }
};
export default request;
